export default __webpack_public_path__ + "static/media/product_13.9329d029.png";